// eslint-disable-next-line import/prefer-default-export
export const showStats = account => {
  const { revoked, suspended_at, as_reply_to, num_pending } = account;
  const isSenderAccount = !revoked && !suspended_at && !as_reply_to;
  if (isSenderAccount) return true;
  if (num_pending) return true; // for in_active accounts only show pending if it's not zero
  return false;
};
